module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img5.8704239f.jpg";